import React, { PropsWithChildren } from 'react'
import { createContext } from 'lib/createContext'
import { useCompanyDetailContextValue } from 'pages/Company/CompanyDetail/context/CompanyDetailProvider'
import { parseErrorMessage } from 'api'
import { useSetCompanyChargeUpfrontMutation } from 'queries/company/useSetCompanyChargeUpfrontMutation'

type EditPaymentMethodFlowProviderContextState = {
  actions: {
    submitFormToServer: ReturnType<
      typeof useSetCompanyChargeUpfrontMutation
    >['mutate']
  }
  state: {
    mutationState: {
      isPending: boolean
      isError: boolean
      errorMessage: string | undefined
    }
  }
}

const [Context, useEditPaymentMethodFlowContextValue] =
  createContext<EditPaymentMethodFlowProviderContextState>({
    name: 'EditPaymentMethodFlowContext',
  })

export const EditPaymentMethodFlowProvider = ({
  children,
}: PropsWithChildren) => {
  const {
    state: { id: companyId },
  } = useCompanyDetailContextValue()

  const { mutate, isPending, isError, error } =
    useSetCompanyChargeUpfrontMutation(companyId)

  const value: EditPaymentMethodFlowProviderContextState = {
    actions: {
      submitFormToServer: mutate,
    },
    state: {
      mutationState: {
        isPending,
        isError,
        errorMessage: parseErrorMessage(error),
      },
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useEditPaymentMethodFlowContextValue }
